import * as serviceInitTypes from './serviceInitTypes';

const initialState = {
  isLoading: false,
  isLoadingBatch: false,
  page: null,
  menu: [],
  menuIndex: 0,
  importId: null,
  importStatus: 'Uploading',
  importProgress: 0,
  showErrors: false,
  errors: [],
};

const serviceInitReducer = (state = initialState, action) => {
  switch (action.type) {
    case serviceInitTypes.SET_SERVICEINIT_MENU: {
      return {
        ...state,
        menu: action.payload.menu,
        menuIndex: action.payload.index,
      };
    }
    case serviceInitTypes.GET_SERVICEINIT_PAGE: {
      return {
        ...state,
        page: null,
        isLoading: true,
      };
    }
    case serviceInitTypes.SET_SERVICEINIT_PAGE: {
      return {
        ...state,
        page: action.payload,
        isLoading: false,
      };
    }
    case serviceInitTypes.REFRESH_MENUS: {
      return {
        ...state,
        page: { ...state.page, menus: action.payload },
        isLoading: false,
      };
    }
    case serviceInitTypes.SET_MENU_INDEX: {
      return {
        ...state,
        menuIndex: action.payload.menuIndex,
      };
    }
    case serviceInitTypes.SET_SPINNER_STATUS: {
      return {
        ...state,
        ...action,
      };
    }
    case serviceInitTypes.RESET_SERVICEINIT:
      return initialState;
    case serviceInitTypes.IS_LOADING_BATCH:
      return {
        ...state,
        isLoadingBatch: action.isLoading,
      };
    case serviceInitTypes.SUBMIT_BATCH_INIT_SUCCESS:
      return {
        ...state,
        importId: action.data.importId,
      };
    case serviceInitTypes.BATCH_INIT_PROGRESS_SUCCESS:
      return {
        ...state,
        importStatus: action.data.status,
        importProgress: action.data.progress,
      };
    case serviceInitTypes.BATCH_INIT_SET_ERRORS:
      return {
        ...state,
        showErrors: action.showErrors,
        errors: action.errors.errorMessages,
        successCountwithRows: action.errors.successCountwithRows,
        failureCountwithRows: action.errors.failureCountwithRows,
      };
    case serviceInitTypes.BATCH_INIT_SHOW_HIDE_ERRORS:
      return {
        ...state,
        showErrors: action.showErrors,
      };
    default:
      return state;
  }
};

export { initialState };
export default serviceInitReducer;
